import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Button3dComponent } from './button3d.component';

@NgModule({
  declarations: [Button3dComponent],
  exports: [Button3dComponent],
  imports: [
    CommonModule
  ]
})
export class Button3dModule { }
